import React from 'react';
import './SalesPromptModal.css';

export default function SalesPromptModal({ onClose }) {
  return (
    <div className="sales-modal-backdrop" role="dialog" aria-modal="true">
      <div className="sales-modal-card">
        <button className="sales-modal-close" onClick={onClose} aria-label="Close">×</button>
        <h2>Unlock Unlimited Audio Guides</h2>
        <ul>
          <li>Unlimited real-time narration</li>
          <li>Top-sight recommendations everywhere</li>
          <li>Early access to new AI features</li>
        </ul>
        <button className="sales-modal-buy">Upgrade for €4.99</button>
      </div>
    </div>
  );
} 